const Theme = {
  colors: {
    primary: '#303f9f',
    secondary: '#8c0343',
    placeholder: '#99a1d2',
  },
};

export default Theme;
